var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header',{attrs:{"company":_vm.company,"use_language":_vm.use_language,"selected_language":_vm.selected_language},on:{"changeLang":_vm.changeLang}}),_c('div',{staticClass:"content-page ml-0 p-0"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid p-0"},[_vm._t("default")],2)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }